import { Dispatch, SetStateAction, useState } from 'react'


export default function useJobsKitsState(): [Array<string>, Dispatch<SetStateAction<string[]>>] {
  const [kits, setKits] = useState<Array<string>>([])

  return [kits, setKits]
}
